import { CustomError } from '../custom-error';

/**
 * Базовая ошибка во время работы xfetch.
 */
export class XFetchError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }
}

/**
 * Базовая ошибка, возникающая, если статус ответа не равен 200.\
 * Добавляет дополнительную информацию о статусе ответа в message. \
 * Содержит поле responseStatus.
 */
export class ResponseStatusNot200Error extends XFetchError {
  responseStatus: number;

  constructor(responseStatus: number, message?: string, options?: ErrorOptions) {
    message = `response.status = ${responseStatus}. ${message}`;
    super(message, options);
    this.responseStatus = responseStatus;
  }
}

/**
 * Эта ошибка связана с невалидными данными в теле запроса или ответа.
 * Возникает, если статус ответа не равен 200 и ответ удалось идентифицировать как ответ от SOWA.
 */
export class SowaError extends ResponseStatusNot200Error {
  constructor(...args: ConstructorParameters<typeof ResponseStatusNot200Error>) {
    super(...args);
  }
}

/**
 * Если статус ответа равен 401 или 403.
 */
export class AuthError extends ResponseStatusNot200Error {
  constructor(...args: ConstructorParameters<typeof ResponseStatusNot200Error>) {
    super(...args);
  }
}

/**
 * Если статус ответа не равен 200 и ошибку не удалось идентифицировать.
 */
export class ResponseUnknownError extends ResponseStatusNot200Error {
  constructor(...args: ConstructorParameters<typeof ResponseStatusNot200Error>) {
    super(...args);
  }
}

/**
 * Если статус ответа равен 200 и текст ответа не удалось распарсить в JSON.
 */
export class ResponseJsonParsingError extends XFetchError {
  constructor(...args: ConstructorParameters<typeof XFetchError>) {
    super(...args);
  }
}
